import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Col,
  CustomInput,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import {
  BtnOutlineGreen,
  ContFilterYear,
  ContFlexRight,
  ContPaginationPage,
} from '../../../../styled-components';
import SearchInput from '../../../../commons/SearchInput';
import generatePaginationOptions from '../../../../lib/helpers/generatePaginationOptions';
import SignalsTable from './SignalsTable';
import generateMonthOptions from '../../../../lib/helpers/generateMonthOptions';
import generateYearOptions from '../../../../lib/helpers/generateYearOptions';
import currency from 'currency.js';
import ModalConfirm from '../../../../commons/ModalConfirm';

const SignalsPresentational = ({
  data,
  profile,
  newIsAdmin,
  query,
  total,
  onFilter,
  selectedSignals,
  onSelectAll,
  onRowClick,
  onInvoice,
  selectedAll,
  onStatusChanged,
}) => {
  const [t] = useTranslation('SIGNALS');
  const { limit, offset } = query;
  const [totalInvoicesValue, setTotalInvoicesValue] = useState(0);

  const onOpenModal = () => {
    const itemsForTotalValue = selectedSignals.map((_id) => {
      const signal = data.find((signal) => signal._id === _id);
      const shareToInvoice = signal.shareToInvoice || 0;
      return shareToInvoice;
    });
    let total = 0;
    itemsForTotalValue.forEach((value) => {
      total += value;
    });
    setTotalInvoicesValue(
      currency(total, { symbol: '€', precision: 2 }).format()
    );
  };

  return (
    <section>
      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <section>
            <Row className="search-add-cont m-t-10" style={{ rowGap: '1rem' }}>
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.signalman }}
                  onFilter={({ search }) => onFilter({ signalman: search })}
                  label={t('SIGNALMAN_SEARCH')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.commercial }}
                  onFilter={({ search }) => onFilter({ commercial: search })}
                  label={t('COMMERCIAL_SEARCH')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.condo }}
                  onFilter={({ search }) => onFilter({ condo: search })}
                  label={t('CONDO_SEARCH')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.notes }}
                  onFilter={({ search }) => onFilter({ notes: search })}
                  label={t('NOTES_SEARCH')}
                />
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('ACCOUNTABILITY_YEAR_FILTER')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="accountabilityYear"
                          name="accountabilityYear"
                          value={query && query.accountabilityYear}
                          onChange={({
                            target: { value: accountabilityYear },
                          }) => onFilter({ accountabilityYear })}
                        >
                          {generateYearOptions(true)}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('ACCOUNTABILITY_MONTH_FILTER')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="accountabilityMonth"
                          name="accountabilityMonth"
                          value={query && query.accountabilityMonth}
                          onChange={({
                            target: { value: accountabilityMonth },
                          }) => onFilter({ accountabilityMonth })}
                        >
                          {generateMonthOptions()}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
            </Row>
          </section>

          <section style={{ marginTop: '1rem' }}>
            <SignalsTable
              data={data}
              total={total}
              offset={offset}
              limit={limit}
              onFilter={onFilter}
              onRowClick={onRowClick}
              onSelectAll={onSelectAll}
              selectedSignals={selectedSignals}
              selectedAll={selectedAll}
              onStatusChanged={onStatusChanged}
            />

            <ContPaginationPage>
              <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

              <FormGroup>
                <CustomInput
                  type="select"
                  className="pagination-select"
                  id="perPage"
                  name="perPage"
                  value={limit}
                  onChange={({ target: { value: limit } }) => {
                    onFilter({ limit: limit });
                  }}
                >
                  {generatePaginationOptions()}
                </CustomInput>
              </FormGroup>
            </ContPaginationPage>

            <ContFlexRight className="mt-5">
              {selectedSignals.length > 0 && (
                <ModalConfirm
                  onConfirm={() => {
                    onInvoice();
                  }}
                  onOpen={onOpenModal}
                  text={
                    `Il valore totale delle segnalazioni é: ${totalInvoicesValue} ` +
                    '\n' +
                    t('CONTACTS:CONFIRM_INVOICE')
                  }
                >
                  <BtnOutlineGreen type="button" className="uppercase">
                    FATTURA SELEZIONATI
                  </BtnOutlineGreen>
                </ModalConfirm>
              )}
            </ContFlexRight>
          </section>
        </TabPane>
      </TabContent>
    </section>
  );
};

export default SignalsPresentational;
